import React, { useState, useEffect } from "react";
import { Row, Col, Form, Button, FormControl, Card } from "react-bootstrap";
import { AiOutlineClose } from "react-icons/ai";
import axios from "axios";
import apiConfig from "../credentials/apiConfig";
import './index.scss';

const InvestmentSchedulesFilterBlock = ({ onApply }) => {
    const [filters, setFilters] = useState({
        search: "",
        client: "All Clients",
        year: "All Years", 
        status: "All Status",
    });

    const [clients, setClients] = useState([]);
    const [loading, setLoading] = useState(false);

    const yearOptions = [
        { id: "all", label: "All Years", value: "All Years" },
        { id: "2025", label: "2025", value: "2025" },
        { id: "2024", label: "2024", value: "2024" },
        { id: "2023", label: "2023", value: "2023" },
        { id: "2022", label: "2022", value: "2022" },
        { id: "2021", label: "2021", value: "2021" },
    ];

    const statusOptions = [
        { id: "all", label: "All Status", value: "All Status" },
        { id: "completed", label: "Completed", value: "Completed" },
        { id: "in-progress", label: "In Progress", value: "In Progress" }
    ];

    useEffect(() => {
        fetchClients();
    }, []);

    const fetchClients = async () => {
        try {
            setLoading(true);
            const response = await axios.get(
                `${apiConfig.apiBaseURL}/getAllClients`,
                {
                    headers: {
                        "x-api-key": apiConfig["x-api-key"],
                        "Content-Type": "application/json",
                    },
                }
            );

            if (response.data && response.data.clients) {
                const clientList = [
                    { id: "all", label: "All Clients", value: "All Clients" },
                    ...response.data.clients.map(client => ({
                        id: client._id,
                        label: client.clientName,
                        value: client.clientName
                    }))
                ];
                setClients(clientList);
            }
        } catch (error) {
            console.error("Error fetching clients:", error);
            setClients([{ id: "all", label: "All Clients", value: "All Clients" }]);
        } finally {
            setLoading(false);
        }
    };

    const handleChange = (e) => {
        if (typeof e.target.value !== "string") {
            console.error(`Invalid value for ${e.target.name}:`, e.target.value);
            return;
        }

        const newFilters = { ...filters, [e.target.name]: e.target.value };
        setFilters(newFilters);

        if (e.target.name === "search") {
            onApply(newFilters);
        }
    };

    const handleApply = () => {
        onApply(filters);
    };

    const handleReset = () => {
        const resetFilters = {
            search: "",
            client: "All Clients",
            year: "All Years",
            status: "All Status",
        };
        setFilters(resetFilters);
        onApply(resetFilters);
    };

    return (
        <Form className="mb-3 credential-page client-page filter-block" onSubmit={(e) => e.preventDefault()}>
            <Card className="pt-3 px-2" style={{ border: '2px solid #ECEEF5' }}>
                <Card.Body>
                    <Row className="pb-1">
                        <Col xl={3} lg={3} md="12" className="mb-3 mb-lg-0">
                            <div style={{ position: "relative" }}>
                                <FormControl
                                    type="text"
                                    name="search"
                                    value={filters.search}
                                    onChange={handleChange}
                                    placeholder="Search"
                                    style={{ paddingRight: "30px" }}
                                />
                                {filters.search && (
                                    <AiOutlineClose
                                        onClick={() => {
                                            const reset = { ...filters, search: "" };
                                            setFilters(reset);
                                            onApply(reset);
                                        }}
                                        style={{
                                            position: "absolute",
                                            right: "10px",
                                            top: "50%",
                                            transform: "translateY(-50%)",
                                            cursor: "pointer",
                                            color: "#999",
                                            fontSize: "16px",
                                        }}
                                    />
                                )}
                            </div>
                        </Col>

                        <Col xl="9" lg={9} md="12">
                            <Row className="justify-content-end">
                                <Col md="2" className="my-auto d-none d-lg-none d-xl-block">
                                    <p className="my-0 fw-bold text-dark" style={{ textAlign: 'right' }}>Filters</p>
                                </Col>

                                <Col xl="3" lg={4} className="mb-3 mb-lg-0">
                                    <Form.Select name="client" value={filters.client} onChange={handleChange} disabled={loading}>
                                        {clients.map((client) => (
                                            <option key={client.id} value={client.value}>
                                                {client.label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>

                                <Col lg="3" className="mb-3 mb-lg-0">
                                    <Form.Select name="year" value={filters.year} onChange={handleChange}>
                                        {yearOptions.map((year) => (
                                            <option key={year.id} value={year.value}>
                                                {year.label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>

                                <Col xl="2" lg={3} className="mb-3 mb-lg-0">
                                    <Form.Select name="status" value={filters.status} onChange={handleChange}>
                                        {statusOptions.map((status) => (
                                            <option key={status.id} value={status.value}>
                                                {status.label}
                                            </option>
                                        ))}
                                    </Form.Select>
                                </Col>

                                <Col lg="2" className="d-flex gap-2">
                                    <Button variant="primary" className="w-100" onClick={handleApply}>Apply</Button>
                                </Col>
                            </Row>
                        </Col>
                        <div className="d-flex justify-content-end">
                            <p className="my-0 fw-bold text-primary w-auto" style={{ textAlign: 'right', cursor: 'pointer' }} onClick={handleReset}>
                                Reset
                            </p>
                        </div>
                    </Row>
                </Card.Body>
            </Card>
        </Form>
    );
};

export default InvestmentSchedulesFilterBlock;